import { Box, IconButton, Stack, Typography } from '@mui/material';

import PageNextIcon from '../../assets/svg/settings/reactivation/paginationNext.svg';
import PagePrevIcon from '../../assets/svg/settings/reactivation/paginationPrev.svg';

interface PaginationComponentProps {
  page: number;
  totalPages: number;
  ItemPerPage: number;
  totalCount: number;
  changePage: (page: number) => void;
  noPaddingY?: boolean;
}

const PaginationComponent = ({ page, totalPages, totalCount, ItemPerPage, changePage, noPaddingY }: PaginationComponentProps) => {

  const nextPageHandler = () => {
    if (page < totalPages)
      changePage(page + 1);
  };
  const prevPageHandler = () => {
    if (page > 1)
      changePage(page - 1);
  };
  return (
    <Stack 
      direction='row' 
      justifyContent='center'
      alignItems='center'
      gap={1}
      sx={{
        marginTop: '15px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.04)',
        borderRadius: '6px',
        border: '1px solid #D6D6D6',
        paddingY: noPaddingY ? '0px' : '8px',
        paddingX: '16px',
        flexGrow: 0,
        width: 'fit-content',
      }}>
      <Typography sx={{
        color: '#878787',
      }}>
        {(page * ItemPerPage) - (ItemPerPage - 1)}-{(page * ItemPerPage) < totalCount ? (page * ItemPerPage) : totalCount} of {totalCount}
      </Typography>
      <Stack direction='row'>
        <IconButton
          disabled={page === 1}
          onClick = {prevPageHandler}>
          <Box component='img' src={PagePrevIcon}/>
        </IconButton>
        <IconButton
          disabled={page === totalPages}
          onClick = {nextPageHandler}>
          <Box component='img' src={PageNextIcon}/>
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default PaginationComponent;